<template>
<div class="append-to-body-container">
  <slot></slot>
</div>
</template>
<script>
export default {
  mounted () {
    document.body.appendChild(this.$el)
  },
  destroyed () {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>
<style lang="less" scoped>
.append-to-body-container {
}
</style>



// WEBPACK FOOTER //
// src/components/appendToBody.vue